<template>
  <div id="new-ring-main-header">
    <div class="nav-left">
      <div class="title">
        <span class="new-ui__header__title">
          <slot>[MENU NAME]</slot>
        </span>
      </div>
      <div class="sub-title">
        {{ headerSubTitle }}
      </div>
      <span
          v-if="isAccountLocked"
          style="display: block;padding-top: 2px;font-size: large;color: red;font-weight: 500;">
        ACCOUNT IS DISABLED!
      </span>
    </div>
    <div class="nav-right">
      <ul class="nav-form">
        <li v-if="showOneOffButton">
          <one-off-button />
        </li>
        <li v-if="showPlcButton">
          <plc-button />
        </li>
        <li>
          <main-search />
        </li>
        <li>
          <user-options />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import UserOptions from "./UserOptions";
import MainSearch from "./Search";
import OneOffButton from "@/components/Shared/OneOffButton";
import PlcButton from "@/components/Shared/PlcButton";
import { createNamespacedHelpers } from "vuex";
import permission from "@/mixins/permission";
import { isEmpty } from "lodash";

const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");

export default {
  name: "MainHeader",
  components: {
    UserOptions,
    MainSearch,
    OneOffButton,
    PlcButton,
  },
  mixins: [permission],
  props: {
    showPlcButton: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    showOneOffButton: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    subTitle: {
      type: String,
      default: undefined,
      required: false,
    },
  },
  data() {
    return {
      search: "",
      oneOffModalShow: false,
    };
  },
  computed: {
    ...accountGetters(["customer", "isLocked"]),
    headerSubTitle() {
      if (isEmpty(this.subTitle)) {
        return this.customer.email;
      }

      return this.subTitle;
    },
    hasNewLeftNavEnabled() {
      return this.hasPermission("NewUI", "leftNav");
    },
    isAccountLocked() {
      return this.isLocked;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/newui/fonts.scss";

.new-ui__header__title {
  @include heading__small-medium();
}
</style>

<style lang="scss">
@import "@/assets/scss/newui/fonts.scss";

.new-ui__left-nav section > main.el-main {
  padding: 25px 48px 41px 48px;
}

#new-ring-main-header {
  margin: 0px 0px 22px 0px;
  height: 55px;
  padding: 0 20px 0 0px;
  @media screen and (max-width: 1280px) {
    height: fit-content;
  }

  .el-input__prefix {
    top: unset !important;
  }

  .nav-left {
    float: left;
  }

  .nav-right {
    float: right;
  }

  .nav-left,
  .nav-right {
    @media screen and (max-width: 1280px) {
      float: none;
    }
  }

  .nav-left .title {
    font-size: 24px;
    color: #4c4c4c;
    font-weight: 300;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 40rem;
  }

  .nav-left .title a {
    font-size: 28px;
    color: #4c4c4c;
    font-weight: 300;
  }

  .nav-left .sub-title {
    @include body__large-medium();
    color: #999999 !important;
    padding-left: 0;
  }

  .nav-right ul.nav-form {
    display: inline-block;
    list-style: none;
    margin: 0px;
    padding: 0px;
  }

  .nav-right ul.nav-form li {
    float: left;
    padding: 5px;
    padding-left: 0;
    padding-right: 0;
    margin-left: 16px;
  }

  .nav-right ul.nav-form li a.nav-action {
    text-decoration: none;
    font-size: 15px;
    color: $--color-curious-blue;
    text-align: center;
    height: 45px;
    line-height: 45px;
  }

  .nav-right ul.nav-form li .nav-search input {
    height: 40px;
    width: 378px;
    line-height: 40px;
    border-radius: 4px;
  }
}

// Override UI Library
.el-form-item__error {
  padding-top: 8px !important;
}
</style>
